export const fileCardImageViewSelector = 'media-file-card-view';
export const fileCardImageViewSelectedSelector = 'media-file-card-view-selected';